import { Mutation, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';

export function mockedUpdateVisitorGroupDetailsData(
  updateVisitorGroupDetails: VisitorGroup
): Pick<Mutation, 'updateVisitorGroupDetails'> {
  return { updateVisitorGroupDetails };
}

export const mockedUpdateVisitorGroupDetailsDataForMutation = mockedUpdateVisitorGroupDetailsData(
  generateMockVisitorGroup({
    id: 'mockedVisitorGroupIdExternalUsers1',
    name: 'co-contractors1',
    maxNumberOfMembers: 3
  })
);

export const mockedUpdateVisitorGroupDetailsClearedMaxNumberOfMembersDataForMutation =
  mockedUpdateVisitorGroupDetailsData(
    generateMockVisitorGroup({
      id: 'mockedVisitorGroupIdExternalUsers1',
      name: 'co-contractors1',
      maxNumberOfMembers: null
    })
  );
